/* eslint-disable no-unused-vars */
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Council, Society } from 'types';
import { State } from 'redux/initialState';
import { useTranslate } from 'hooks/useTranslate';

import Switch from 'modules/_shared/components/Switch';
import CouncilDetailsPageHeader from '../../CouncilDetails/components/CouncilDetailsPageHeader';

type CouncilMembersHeaderProps = {
  council: Council | null;
  society: Society | null;
  isAdminView: boolean;
  onViewModeChange: (isAdminView: boolean) => void;
};

const CouncilMembersHeader: FC<CouncilMembersHeaderProps> = ({
  council,
  society,
  isAdminView,
  onViewModeChange,
}) => {
  const { t } = useTranslate();

  const isAdmin = useSelector((state: State) => state.society?.role?.isAdmin);

  return (
    <>
      <div className="nk-block-head nk-block-between">
        <div className="nk-block-head-content">
          <nav>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to={`/sociedad/${society?._id}`}>{society?.name}</Link>
              </li>
              <li className="breadcrumb-item active">
                <Link to={`/consejos/${society?._id}`}>{t('Councils')}</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {council?.name}
              </li>
            </ul>
          </nav>
        </div>

        {isAdmin && (
          <div className="nk-block-head-content">
            <div className="d-flex align-items-center">
              <Switch
                id="view-mode-switch"
                checked={isAdminView}
                onChange={onViewModeChange}
                className="mx-2"
                leftLabel={t('DirectorView')}
                rightLabel={t('AdminView')}
              />
            </div>
          </div>
        )}
      </div>

      <CouncilDetailsPageHeader
        council={council as Council}
        isAdminView={isAdminView}
      />
    </>
  );
};

export default CouncilMembersHeader;
